export default __webpack_public_path__ + "static/media/immutable.b822e90e.svg";